import Image from 'next/image'

type WorkRelationShipProps = {
  url: string
}

export const WorkRelationship = ({ url }: WorkRelationShipProps) => {
  return (
    <section
      aria-labelledby="work-relationship"
      className="relative pt-16 pb-32"
    >
      <h2 id="work-relationship" className="text-md font-bold">
        関係図
      </h2>
      <div className="relative px-16 w-full h-[500px]">
        <Image
          src={url}
          alt="関係図"
          layout="fill"
          objectFit="contain"
          className="mt-16 pointer-events-none"
        />
      </div>
    </section>
  )
}
